import { Box, BoxProps, styled } from "@mui/material";
import React from "react";

export const RelativeBox = styled(
  Box,
  {}
)<BoxProps>(() => ({
  m: 1,
  position: "relative",
})) as React.ComponentType<BoxProps>;
